// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RelatedArticleItem_wrapper__1Au04","image":"RelatedArticleItem_image__1IIXH","title":"RelatedArticleItem_title__cjqAX","date":"RelatedArticleItem_date__3xxgB"};